import { Component } from '@angular/core';

@Component({
  selector: 'icon-edificio',
  imports: [],
  templateUrl: './edificio.html',
  styleUrl: './edificio.scss'
})
export class EdificioIcon {

}
